<template>
  <component
    :is="component"
    :student="student"
    :program="program"
    @update-component="changeComponent($event)"
  />
</template>

<script>
import { hasMyStudentsToDosEnabled } from "@/composables/authorization.js";
import ProgramSessionDates from "../../mixins/ProgramSessionAndDates";
import Spinner from "../helpers/Spinner";
import AbroadForm from "./forms/AbroadLetter";
import InternshipForm from "./forms/InternshipLetter";
import ThankYouComponent from "./ThankYouComponent";

export default {
  components: {
    "internship-form": InternshipForm,
    "abroad-form": AbroadForm,
    Spinner: Spinner,
    "thank-you": ThankYouComponent,
  },
  mixins: [ProgramSessionDates],
  props: {
    applicationHash: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      component: "Spinner",
      student: {},
      program: {},
    };
  },
  async mounted() {
    try {
      // Validating Student Data
      const studentRequest = await this.validateStudent();
      if (!this.guardStudentData(studentRequest)) return;
      this.student = studentRequest;

      // Gathering Program Data
      const programRequest = await this.getProgramSessionAndDates({
        program_id: studentRequest["program_id"],
        apolloClient: this.$apollo,
      });
      if (!this.guardProgramData(programRequest)) return;
      this.program = programRequest["data"]["programSessionBySalesforceId"];
    } catch (error) {
      console.error(error);
      return;
    }

    // Setting up form
    // To-dos flag ON always uses the abroad-form version
    const useInternshipForm = !hasMyStudentsToDosEnabled.value && this.program["program"]["internship"];
    this.changeComponent(useInternshipForm ? "internship-form" : "abroad-form");
  },
  methods: {
    validateStudent() {
      const postData = {
        hash: this.applicationHash,
      };
      return fetch(this.trailingSlash(import.meta.env.VITE_ENROLLMENT_SERVICE_ENDPOINT) + "recommendation/validate", {
        method: "post",
        body: JSON.stringify(postData),
        headers: {
          "Content-type": "application/json",
        },
        mode: "cors",
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            return false;
          }
        })
        .catch((e) => {
          console.warn(e);
          return false;
        });
    },
    changeComponent(updatedComponent) {
      this.component = updatedComponent;
    },
    guardStudentData(data) {
      if (!data) return false;
      if (!Object.hasOwn(data, "program_id")) return false;
      return true;
    },
    guardProgramData(data) {
      if (!data) return false;
      if (!Object.hasOwn(data, "data")) return false;
      if (!Object.hasOwn(data["data"], "programSessionBySalesforceId")) return false;
      if (!Object.hasOwn(data["data"]["programSessionBySalesforceId"], "program")) return false;
      return true;
    },
  },
};
</script>
